// @ts-expect-error
/* eslint-disable */
import { request } from '@umijs/max';

/** 11103-手环录入 POST /web/v1/bracelet/add */
export async function addBracelet(
  body: API.SwimBraceletAddVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/bracelet/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11107-手环绑定(机器回调) -- 内部使用30101接口 POST /web/v1/bracelet/bind */
export async function bindBracelet(
  body: API.SwimBraceletBindVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/bracelet/bind', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11105-手环删除 GET /web/v1/bracelet/delete/${param0} */
export async function deleteBracelet(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteBraceletParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/bracelet/delete/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 11102-手环详情查询 GET /web/v1/bracelet/detail/${param0} */
export async function getBraceletDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getBraceletDetailParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimBraceletDetailVo>(
    `/web/v1/bracelet/detail/${param0}`,
    {
      method: 'GET',
      params: { ...queryParams },
      ...(options || {}),
    },
  );
}

/** 11101-手环列表查询 POST /web/v1/bracelet/list */
export async function getBraceletList(
  body: API.SwimBraceletListQueryVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOYmPageResVOSwimBraceletListVo>(
    '/web/v1/bracelet/list',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 11108-手环结算(机器回调) POST /web/v1/bracelet/unbind */
export async function unbindBracelet(
  body: API.SwimBraceletUnbindVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/bracelet/unbind', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11104-手环修改 POST /web/v1/bracelet/update */
export async function updateBracelet(
  body: API.SwimBraceletUpdateVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/bracelet/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 11106-手环状态修改 POST /web/v1/bracelet/updateStatus */
export async function updateBraceletStatus(
  body: API.SwimBraceletStatusUpdateVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/bracelet/updateStatus', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
